import Page from 'front/pages/Page/Page';
import Urls from 'django_js_front/reverse.js';
import * as _ from 'underscore';

import TopBar from 'front/components/Common/TopBar/TopBar';
import AnimationItem from 'front/components/AnimationComponents/AnimationItem/AnimationItem';
import AnimationItemTemplate
from 'front/components/AnimationComponents/AnimationItem/AnimationItemFrontendRendering.jinja';

import { VIEWPORT_EVENTS } from '../../constants/Constants';
import axios from 'axios';
import './Animations.less';

import * as Template from './Animations.jinja';

const Selectors = {
    el: '.Animations',
    item: '.AnimationItem img',
    itemPlay: '.AnimationItem svg',
    onMoreButton: '.Animations-more',
    topBarFilters: '.TopBar-filters',
    tobBarFilterItem: '.TopBar-filtersItem'
};

const BindFunctions = [
    'onMoreLinkClick',
    'onLoad'
];

export default class Animations extends Page {
    events() {
        return {
            [`${VIEWPORT_EVENTS.click} ${Selectors.onMoreButton}`]: this.onMoreLinkClick,
            [`${VIEWPORT_EVENTS.click} ${Selectors.item}`]: this.onItem,
            [`${VIEWPORT_EVENTS.click} ${Selectors.itemPlay}`]: this.onItemPlay
        };
    }

    constructor(options = {}) {
        options.el = Selectors.el;
        options.VIEWS_TO_REGISTER = {
            'top-bar': { selector: '.TopBar', viewConstructor: TopBar },
            'animation-item': { selector: '.AnimationItem', viewConstructor: AnimationItem }
        };
        options.template = Template;
        super(options);
        _.bindAll(this, BindFunctions);

        this.$more = this.$('.Animations-more');
        this.$moreContent = this.$('.Animations-wrapper');
        this.count = 10;
    }

    onItem(e) {
        e.preventDefault();
        const $target = $(e.currentTarget);
        $target.addClass('hide');
        $target.parent().find('svg')
            .addClass('hide');

        // Получаем iframe
        const $iframe = $target.parent().find('iframe');

        // Получаем исходный URL из data-frame
        const $frame = $target.parent().find('.AnimationItem-frame');
        if ($frame.data('frame')) {
            $iframe[0].src = $($frame.data('frame'))[0].src;
        }

        // Добавляем параметр автовоспроизведения после короткой задержки
        setTimeout(() => {
            this.addAutoplayParameter($iframe[0]);
        }, 500);
    }

    onItemPlay(e) {
        const $target = $(e.currentTarget);
        $target.addClass('hide');
        $target.parent().find('img')
            .addClass('hide');

        // Получаем iframe
        const $iframe = $target.parent().find('iframe');

        // Получаем исходный URL из data-frame
        const $frame = $target.parent().find('.AnimationItem-frame');
        if ($frame.data('frame')) {
            $iframe[0].src = $($frame.data('frame'))[0].src;
        }

        // Добавляем параметр автовоспроизведения после короткой задержки
        setTimeout(() => {
            this.addAutoplayParameter($iframe[0]);
        }, 500);
    }

    // Новый метод для добавления параметра автовоспроизведения
    addAutoplayParameter(iframe) {
        if (!iframe) return;

        const currentSrc = iframe.src;

        // Проверяем, содержит ли URL уже параметры запроса
        if (currentSrc.includes('?')) {
            // Если уже есть параметры, добавляем параметр autoplay через &
            iframe.src = currentSrc + '&autoplay=1';
        } else {
            // Если параметров нет, добавляем параметр autoplay через ?
            iframe.src = currentSrc + '?autoplay=1';
        }
    }

    onLoad(data) {
        if (data) {
            for (let i = 0; i <= data.length && data[i] !== undefined; i++) {
                var $moreItems = $(AnimationItemTemplate.render({
                    animation: data[i],
                    language: window.app.settings.language
                }));

                this.$moreContent.append($moreItems);
            }

            this.count += data.length;
            this.observer.observe();
            this.onResize();

            if (this.$moreContent.data('length') <= this.count) {
                this.$more.addClass('hidden');
            }
        }
    }

    onMoreLinkClick() {
        axios.get(Urls['front:api:animations'](), {
            params: {
                loaded: this.count
            }
        }).then(response => {
            this.$more.addClass('isHide');
            this.onLoad(response?.data);
        });

        setTimeout(() => {
            this.$more.outerHeight();
            this.$more.show(200);
        }, 500);
    }
}
